import { css } from "styled-components";
import token from "styled-token";
import { StyledCheckbox } from "../../components/Checkbox/Checkbox";
import { disabledCursorMixin } from "../disabledCursorMixin";
import { disabledOpacityMixin } from "../disabledOpacityMixin";
var backgroundImageOn = token("Switch.iconColorOn", function (fill) {
  return encodeURIComponent("<svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.8 7.2a.7.7 0 0 0-1 0l-4.4 5L6 10a.7.7 0 0 0-1 0c-.2.2-.2.6 0 .9L8 13.5c.1.2.3.2.5.2.1 0 .3 0 .4-.2l5-5.4c.3-.2.3-.7 0-1z\" fill=\"" + fill + "\"/></svg>");
});
var backgroundImageOff = token("Switch.iconColorOff", function (fill) {
  return encodeURIComponent("<svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.8 10l3-3c.2-.2.2-.6 0-.8-.3-.3-.7-.3-.9 0l-3 3-2.8-3c-.3-.3-.7-.3-1 0-.1.2-.2.6 0 .9l3 2.9-3 3c-.2.2-.2.6 0 .8l.5.2c.2 0 .3 0 .5-.2l2.9-3 3 3 .4.2c.1 0 .3 0 .4-.2.3-.2.3-.6 0-.9l-3-2.9z\" fill=\"" + fill + "\"/></svg>");
});

var sizeCSS = function sizeCSS(props) {
  var size = props.size;
  return token({
    height: "Switch.sizes." + size + ".height",
    width: "Switch.sizes." + size + ".width",
    padding: "Switch.sizes." + size + ".padding"
  }, function (_ref) {
    var height = _ref.height,
        width = _ref.width,
        padding = _ref.padding;
    var iconSize = height - 2 * padding;
    return css(["height:", "px;width:", "px;border-radius:", "px;&:before{top:", "px;left:", "px;height:", "px;width:", "px;background-size:", "px;}", ":checked + &:before{left:", "px;}"], height, width, height / 2, padding, padding, iconSize, iconSize, iconSize, StyledCheckbox, width - iconSize - padding);
  })(props);
};

var switchCSS = function switchCSS(props) {
  return token({
    backgroundColor: "Switch.backgroundColor",
    backgroundColorChecked: "Switch.backgroundColorChecked",
    focusBoxShadow: "shadows.focus",
    iconBackgroundColorOn: "Switch.iconBackgroundColorOn",
    iconBackgroundColorOff: "Switch.iconBackgroundColorOff",
    transition: "Switch.transition"
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
        backgroundColorChecked = _ref2.backgroundColorChecked,
        focusBoxShadow = _ref2.focusBoxShadow,
        iconBackgroundColorOn = _ref2.iconBackgroundColorOn,
        iconBackgroundColorOff = _ref2.iconBackgroundColorOff,
        transition = _ref2.transition;
    return css(["display:inline-block;user-select:none;cursor:pointer;background-color:", ";&[aria-disabled=\"true\"]{", "}&,&:before{transition:", ";}position:relative;&:before{content:\"\";position:absolute;border-radius:50%;background-color:", ";background-image:url(\"data:image/svg+xml,", "\");}", ":checked + &{background-color:", ";}", ":checked + &[aria-disabled=\"true\"]{", "}", ":checked + &:before{content:\"\";background-color:", ";background-image:url(\"data:image/svg+xml,", "\");}", ":not(:checked) + &[aria-disabled=\"true\"]:before{", "}", ":focus + &{box-shadow:", ";}", ""], backgroundColor, disabledCursorMixin(Object.assign({}, props, {
      disabled: true
    })), transition, iconBackgroundColorOff, backgroundImageOff(props), StyledCheckbox, backgroundColorChecked, StyledCheckbox, disabledOpacityMixin(Object.assign({}, props, {
      disabled: true
    })), StyledCheckbox, iconBackgroundColorOn, backgroundImageOn(props), StyledCheckbox, disabledOpacityMixin(Object.assign({}, props, {
      disabled: true
    })), StyledCheckbox, focusBoxShadow, sizeCSS(props));
  })(props);
};

var zsgCompatCSS = function zsgCompatCSS(props) {
  return token({
    iconBackgroundColorOn: "Switch.iconBackgroundColorOn",
    iconBackgroundColorOff: "Switch.iconBackgroundColorOff",
    transition: "Switch.transition"
  }, function (_ref3) {
    var iconBackgroundColorOn = _ref3.iconBackgroundColorOn,
        iconBackgroundColorOff = _ref3.iconBackgroundColorOff,
        transition = _ref3.transition;
    return css(["", " &&{", "}&&&:before{content:\"\";border:none;background-color:", ";transition:", ";box-shadow:none;}", ":checked + &&&:before{background-color:", ";}"], switchCSS(props), sizeCSS(props), iconBackgroundColorOff, transition, StyledCheckbox, iconBackgroundColorOn);
  })(props);
};
/** @class SwitchMixin */

/** @method */


export var SwitchMixin = process.env.NODE_ENV === "test" ? switchCSS : zsgCompatCSS;